import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = { className?: string; children: ReactNode };

export function Card({ className, children }: Props) {
  return (
    <div className={cn("rounded-lg border bg-card text-card-foreground shadow-sm", className)}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children }: Props) {
  return (
    <div className={cn("flex flex-col gap-1 px-4 pt-4 md:px-5 md:pt-5", className)}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children }: Props) {
  return (
    <h2 className={cn("text-base font-semibold leading-snug text-foreground", className)}>
      {children}
    </h2>
  );
}

export function CardDescription({ className, children }: Props) {
  return <p className={cn("text-sm text-muted-foreground", className)}>{children}</p>;
}

export function CardContent({ className, children }: Props) {
  return <div className={cn("p-4 md:p-5", className)}>{children}</div>;
}
